<template>
  <div class="container v-content-container tooltip-wrapper popup-wrapper">
    <div class="row">
      <div class="col-xs-12">
        <h1>
          <i class="fa fa-fw fa-lg fa-list-alt"></i>
          <span v-if="selectedEventId != null">
            {{ noDataExist ? "Event" : originalName }}
          </span>
          <span v-else-if="!loading">
            {{ $label("event.new_event", "New event") }}
          </span>
        </h1>
      </div>
    </div>

    <navigation-tabs :event-id="selectedEventId"></navigation-tabs>

    <div class="row"><div class="col-xs-12">&nbsp;</div></div>

    <error404 v-if="noDataExist" />

    <template v-else>
      <!-- confirm course-delete dialog -->
      <div
        class="modal fade"
        id="dataConfirmModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                &times;
              </button>
              <h3 class="modal-title" id="myModalLabel">
                <i class="fa fa-fw fa-lg fa-trash-o text-danger"></i> Kurs
                löschen?
              </h3>
            </div>

            <div class="modal-body">
              Diesen Kurs mit allen Terminen löschen und die Termine für andere
              Buchungen freigeben?
              <br /><br />
              <b>Achtung: Das Löschen kann nicht rückgängig gemacht werden!</b>
            </div>

            <div class="modal-footer">
              <div id="delete-course-form">
                <button
                  class="btn btn-default"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  Abbrechen
                </button>
                <button
                  class="btn btn-danger"
                  id="delete-course-confirm"
                  type="submit"
                >
                  Jetzt löschen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- overwrite course trainer dialog -->
      <div
        class="modal fade"
        id="courseTrainerModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="courseTrainerModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                &times;
              </button>
              <h3 class="modal-title" id="courseTrainerModalLabel">
                <i class="fa fa-fw fa-lg fa-bolt text-warning"></i> Kurstrainer
                angleichen
              </h3>
            </div>

            <div class="modal-body">
              Für diesen Kurs existieren bereits spezielle
              Trainer-Einstellungen.
              <br /><br />
              Mit dem Button <b>Anpassen</b> kann man sämtliche Termine auf den
              neuen Trainer ändern. Danach haben sämtliche Termine den Trainer,
              der auch im Kurs selbst eingetragen ist. <br /><br />
              Mit dem Button <b>Belassen</b> werden Termine, bei denen ein
              spezieller, abweichender Trainer eingetragen ist, nicht mit
              angepasst.
            </div>

            <div class="modal-footer">
              <button
                class="btn btn-default"
                data-dismiss="modal"
                aria-hidden="true"
              >
                Abbrechen
              </button>
              <button
                class="btn btn-warning"
                id="courseTrainerModalForce"
                type="submit"
              >
                Anpassen
              </button>
              <button
                class="btn btn-primary"
                id="courseTrainerModalKeep"
                type="submit"
              >
                Belassen
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- confirm course-disable dialog -->
      <div
        class="modal fade"
        id="disableCourseModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="disableCourseModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                &times;
              </button>
              <h3 class="modal-title" id="disableCourseModalLabel">
                <i class="fa fa-fw fa-lg fa-pause text-warning"></i> Kurs
                absagen?
              </h3>
            </div>

            <div class="modal-body">
              Das Absagen des Kurses löscht alle Termine, so dass Kursbuchungen
              nicht mehr möglich sind.
              <br /><br />

              <b
                >Achtung: Bestehende Kursbuchungen werden storniert und die
                Kunden entsprechend benachrichtigt.</b
              >
              <br /><br />

              <div class="v-form v-form-borderless">
                <fieldset>
                  <div class="row">
                    <label class="checkbox state-success">
                      <input
                        id="sendCancelEmails"
                        type="checkbox"
                        name="sendinfo"
                        value="true"
                        checked
                      />
                      <i></i> Kursteilnehmer per Email benachrichtigen
                    </label>
                    <label class="note">&nbsp;</label>
                  </div>

                  <div class="row" id="cancelEmailReason">
                    <label class="label">Bitte geben Sie einen Grund an:</label>
                    <label class="textarea">
                      <i class="icon-append icon-comment"></i>
                      <textarea rows="4" name="cancel_reason"></textarea>
                    </label>
                  </div>
                </fieldset>
              </div>
            </div>

            <div class="modal-footer">
              <button
                class="btn btn-default"
                data-dismiss="modal"
                aria-hidden="true"
              >
                Abbrechen
              </button>
              <button
                class="btn btn-warning"
                id="disableCourseConfirm"
                type="submit"
              >
                Jetzt absagen
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- "PLEASE WAIT" layer, displayed as long as course deletion is in progress -->
      <div class="modal fade" id="pleaseWait">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                <strong
                  ><i class="text-primary fa fa-fw fa-lg fa-info-circle"></i
                ></strong>
                Hinweis
              </h4>
            </div>
            <div class="modal-body" id="pleaseWaitContent">
              <p>
                Der Kurs wird gelöscht. Je nach Datenmenge kann dies einige
                Sekunden dauern.
              </p>
            </div>
            <div class="modal-footer">
              <i class="text-primary fa fa-fw fa-lg fa-map-marker fa-spin"></i>
              Diese Seite aktualisiert sich nach Beendigung der Aktion von
              selbst.
            </div>
          </div>
        </div>
      </div>

      <!-- modal dialog to upload/crop/change an image -->
      <div
        class="modal fade"
        id="eventImgModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="eventImgModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content tooltip-wrapper">
            <div id="update-img-form">
              <input
                type="hidden"
                name="controlData"
                id="controlData"
                value=""
              />
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  &times;
                </button>
                <h3 class="modal-title" id="eventImgModalLabel">
                  <i class="text-primary fa fa-fw fa-lg fa-image"></i>
                  {{ $label("common.edit_image", "Edit image") }}
                </h3>
              </div>

              <div class="modal-body text-center">
                <div id="cropper-img">
                  <img
                    id="event-image-img"
                    :src="newUrl"
                    class="img-responsive img-thumbnail col-12 col"
                  />
                </div>
                <div class="">
                  <span
                    class="btn btn-primary btn-lg btn-file"
                    v-tooltip="{
                      content: $label(
                        'common.upload_new_image',
                        'Upload new image'
                      ),
                      classes: 'custom-tooltip'
                    }"
                  >
                    <i class="fa fa-lg fa-fw fa-upload"></i>
                    <input
                      id="cropper-upload"
                      name="file"
                      type="file"
                      ref="eventImage"
                      accept="image/*"
                      @change="onImageFileChange"
                    />
                  </span>
                  <button
                    id="cropper-zoom-in"
                    class="btn btn-primary"
                    v-tooltip="{
                      content: $label('common.enlarge_image', 'Enlarge image'),
                      classes: 'custom-tooltip'
                    }"
                  >
                    <i class="fa fa-lg fa-fw fa-plus-circle"></i>
                  </button>
                  <button
                    id="cropper-zoom-out"
                    class="btn btn-primary"
                    v-tooltip="{
                      content: $label('common.reduce_image', 'Reduce image'),
                      classes: 'custom-tooltip'
                    }"
                  >
                    <i class="fa fa-lg fa-fw fa-minus-circle"></i>
                  </button>
                </div>
              </div>

              <div class="modal-footer">
                <button
                  class="btn btn-default"
                  data-dismiss="modal"
                  aria-hidden="true"
                  @click="newUrl = url"
                >
                  {{ $label("common.cancel", "Cancel") }}
                </button>
                <button
                  class="btn btn-primary"
                  id="save-img"
                  :class="{
                    disabled: placeHolderUrl == newUrl || newUrl == null
                  }"
                  data-dismiss="modal"
                  @click="onUpdateEventImage"
                >
                  {{ $label("common.ok", "OK") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="loading" class="row">
        <div class="col-xs-12">
          <view-loader
            margin-top-pixels="15"
            border-color="primary"
          ></view-loader>
        </div>
      </div>

      <div v-show="!loading" class="row">
        <input type="hidden" name="event_id" value="" />
        <input
          type="hidden"
          name="forceTrainerUpdate"
          id="forceTrainerUpdate"
          value=""
        />

        <div class="col-sm-6">
          <h2>
            <i class="fa fa-fw fa-lg fa-list-alt"></i>
            {{ $label("event.event_data", "Event data") }}
          </h2>
          <p></p>
          <div class="v-form-partial">
            <div class="v-form">
              <fieldset>
                <div class="row">
                  <!-- BEGIN Name-->
                  <section class="col col-8">
                    <text-input
                      v-model="selectedEvent.name"
                      id="event-name"
                      :label="$label('common.name', 'Name')"
                      :placeholder="$label('common.name', 'Name')"
                      :has-error="hasError('name')"
                      :error="getError('name')"
                      :is-disabled="updating"
                      @keyup.native.enter="createOrUpdateEvent"
                    />
                  </section>
                  <!-- END Name -->

                  <!-- BEGIN Short name -->
                  <section class="col col-4">
                    <text-input
                      v-model="selectedEvent.short_name"
                      id="event-short-name"
                      :label="$label('event.short_name', 'Short name')"
                      :placeholder="$label('event.short_name', 'Short name')"
                      :has-error="hasError('short_name')"
                      :error="getError('short_name')"
                      :is-disabled="updating"
                      @keyup.native.enter="createOrUpdateEvent"
                    />
                  </section>
                  <!-- END Short name -->
                </div>

                <!-- END Type -->
                <section>
                  <label class="label">{{
                    $label("event.type", "Type")
                  }}</label>
                  <label class="select">
                    <select v-model="selectedEvent.type" id="event-type">
                      <option
                        v-for="eventType in eventTypes"
                        :value="eventType"
                        v-bind:key="eventType"
                        >{{ eventType }}</option
                      >
                    </select>
                    <i></i>
                  </label>

                  <p v-if="hasError('type')" class="text-danger">
                    {{ getError("type") }}
                  </p>
                </section>
                <!-- END Type -->

                <div class="row">
                  <!-- BEGIN Start date -->
                  <section class="col col-6">
                    <label class="label">{{
                      $label("event.start_date", "Start date")
                    }}</label>
                    <date-picker
                      v-model="selectedEvent.start_date"
                      :format="dateFormat"
                      :readonly="updating"
                      :disabled="updating"
                      :placeholder="dateFormat"
                      class="input"
                      id="event-start-date"
                      :class="{ 'text-input-error': hasError('start_date') }"
                    >
                    </date-picker>

                    <p v-if="hasError('start_date')" class="text-danger">
                      {{ getError("start_date") }}
                    </p>
                  </section>
                  <!-- END Start date -->

                  <!-- BEGIN End date -->
                  <section class="col col-6">
                    <label class="label">{{
                      $label("event.end_date", "End date")
                    }}</label>
                    <date-picker
                      v-model="selectedEvent.end_date"
                      :format="dateFormat"
                      :readonly="updating"
                      :disabled="updating"
                      :placeholder="dateFormat"
                      class="input"
                      id="event-end-date"
                      :class="{ 'text-input-error': hasError('end_date') }"
                    >
                    </date-picker>

                    <p v-if="hasError('end_date')" class="text-danger">
                      {{ getError("end_date") }}
                    </p>
                  </section>
                  <!-- END End date -->
                </div>

                <!-- BEGIN Description -->
                <section>
                  <label class="label">{{
                    $label("common.description", "Description")
                  }}</label>
                  <label class="textarea">
                    <textarea
                      v-model="selectedEvent.description"
                      :class="{ 'text-input-error': hasError('description') }"
                      :placeholder="$label('common.description', 'Description')"
                      :disabled="updating"
                      id="event-description"
                      rows="3"
                    >
                    </textarea>
                  </label>
                </section>
                <!-- END Description -->

                <div class="row">
                  <!-- BEGIN Instructor -->
                  <section
                    class="col col-12"
                    id="event-selected-instructor-multiselect"
                  >
                    <label class="label typo__label">
                      {{ $label("instructor.instructor", "Instructor") }}</label
                    >
                    <multiselect
                      v-model="instructorValue"
                      tag-placeholder=""
                      :placeholder="
                        $label(
                          'event.search_or_add_instructor',
                          'Search or add instructor'
                        )
                      "
                      label="name"
                      track-by="id"
                      :options="instructorOptions"
                      class="v-multiselect v-form"
                      :multiple="true"
                      :taggable="false"
                      :show-labels="false"
                      @search-change="updateInstructorSearchFilter"
                      @tag="addInstructor"
                    >
                    </multiselect>
                    <div>
                      <a
                        @click="instructorValue = instructorOptions"
                        class="note action-link pull-right"
                        id="selectAllInstructors"
                        >{{ $label("event.select_all", "Select all") }}</a
                      >
                      &nbsp;
                      <a
                        @click="instructorValue = []"
                        class="note action-link pull-right"
                        id="removeAllInstructor"
                        >{{ $label("event.select_all", "Remove all") }}</a
                      >
                    </div>

                    <p v-if="hasError('instructor_ids')" class="text-danger">
                      {{ getError("instructor_ids") }}
                    </p>
                  </section>
                  <!-- END Instructor -->

                  <!-- BEGIN Accounting by -->
                  <section class="col col-12">
                    <label class="label">{{
                      $label("event.accounting_by", "Accounting by")
                    }}</label>
                    <label v-show="selectedEvent.freebie" class="note">{{
                      $label("event.free_event", "Free event")
                    }}</label>
                    <label v-show="!selectedEvent.freebie" class="select">
                      <select id="event-accounting-by">
                        <option
                          :selected="accountingBy == 'partner'"
                          value="partner"
                          >Operator Name</option
                        >
                        <option
                          :selected="accountingBy == 'instructor'"
                          :disabled="!accountableByInstructor"
                          id="instructor-accountable"
                          value="instructor"
                          >{{
                            $label("instructor.instructor", "Instructor")
                          }}</option
                        >
                      </select>
                      <i></i>
                    </label>
                  </section>
                  <!-- BEGIN Accounting by -->
                </div>

                <!-- BEGIN Event host -->
                <section v-show="handleEventHost">
                  <label class="label">{{
                    $label("event.event_host", "Event host")
                  }}</label>
                  <label class="textarea">
                    <textarea
                      :class="{ 'text-input-error': hasError('event_host') }"
                      :placeholder="$label('event.event_host', 'Event host')"
                      :disabled="updating"
                      id="event-host"
                      rows="3"
                    >
                    </textarea>
                  </label>
                </section>
                <!-- END Event host -->
              </fieldset>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <h2>
            <i class="fa fa-fw fa-lg fa-cog"></i>
            {{ $label("event.settings", "Settings") }}
          </h2>
          <p></p>
          <div class="v-form-partial">
            <div class="v-form">
              <fieldset>
                <div class="row">
                  <!-- BEGIN Bookable online -->
                  <section class="col col-6">
                    <label class="label">{{
                      $label("event.bookable_online", "Bookable online")
                    }}</label>
                    <label class="select">
                      <select
                        v-model="selectedEvent.bookable_online"
                        id="event-bookable-online"
                      >
                        <option value="true">{{
                          $label("common.yes", "Yes")
                        }}</option>
                        <option value="false">{{
                          $label("common.no", "No")
                        }}</option>
                      </select>
                      <i></i>
                    </label>
                  </section>
                  <!-- END Bookable online -->

                  <!-- BEGIN Bookability -->
                  <section class="col col-6">
                    <label class="label">{{
                      $label("event.bookability", "Bookability")
                    }}</label>
                    <label class="select">
                      <select
                        v-model="selectedEvent.bookability"
                        id="event-bookability"
                      >
                        <option value="public">{{
                          $label("event.public", "Public")
                        }}</option>
                        <option value="members">{{
                          $label("event.members_only", "Members only")
                        }}</option>
                        <option value="groups">{{
                          $label("event.selected_groups", "Selected groups")
                        }}</option>
                        <option value="notbookable">{{
                          $label("event.not_bookable", "Not bookable")
                        }}</option>
                      </select>
                      <i></i>
                    </label>

                    <p v-if="hasError('bookability')" class="text-danger">
                      {{ getError("bookability") }}
                    </p>
                  </section>
                  <!-- END Bookability -->
                </div>

                <div
                  v-show="selectedEvent.bookability == 'groups'"
                  class="row"
                  id="bookable-customer-groups"
                >
                  <!-- BEGIN Selected groups -->
                  <section
                    class="col col-12"
                    id="event-selected-group-multiselect"
                  >
                    <label class="label typo__label">
                      {{
                        $label("event.selected_groups", "Selected groups")
                      }}</label
                    >
                    <multiselect
                      v-model="groupValue"
                      tag-placeholder=""
                      :placeholder="
                        $label(
                          'event.search_or_add_group',
                          'Search or add group'
                        )
                      "
                      label="name"
                      track-by="id"
                      :options="groupOptions"
                      class="v-multiselect v-form"
                      :multiple="true"
                      :taggable="false"
                      :show-labels="false"
                      @tag="addGroup"
                    >
                    </multiselect>
                    <div>
                      <a
                        @click="groupValue = groupOptions"
                        class="note action-link pull-right"
                        id="selectAllGroups"
                        >{{ $label("event.select_all", "Select all") }}</a
                      >
                      &nbsp;
                      <a
                        @click="groupValue = []"
                        class="note action-link pull-right"
                        id="removeAllGroups"
                        >{{ $label("event.select_all", "Remove all") }}</a
                      >
                    </div>

                    <p v-if="hasError('groups')" class="text-danger">
                      {{ getError("groups") }}
                    </p>
                  </section>
                  <!-- END Selected groups -->
                </div>

                <div class="row">
                  <!-- BEGIN Bookable from -->
                  <section class="col col-sm-12 col-lg-6">
                    <label class="label">{{
                      $label("event.bookable_from", "Bookable from")
                    }}</label>
                    <date-picker
                      v-model="selectedEvent.bookable_from"
                      type="datetime"
                      :format="dateTimeFormat"
                      :readonly="updating"
                      :disabled="updating"
                      :placeholder="dateTimeFormat"
                      class="input"
                      id="event-bookable-from"
                      :class="{ 'text-input-error': hasError('bookable_from') }"
                    >
                    </date-picker>

                    <p v-if="hasError('bookable_from')" class="text-danger">
                      {{ getError("bookable_from") }}
                    </p>
                  </section>
                  <!-- END Bookable from -->

                  <!-- BEGIN Bookable to -->
                  <section class="col col-sm-12 col-lg-6">
                    <label class="label">{{
                      $label("event.bookable_until", "Bookable until")
                    }}</label>
                    <date-picker
                      v-model="selectedEvent.bookable_until"
                      type="datetime"
                      :format="dateTimeFormat"
                      :readonly="updating"
                      :disabled="updating"
                      :placeholder="dateTimeFormat"
                      class="input"
                      id="event-bookable-until"
                      :class="{
                        'text-input-error': hasError('bookable_until')
                      }"
                    >
                    </date-picker>

                    <p v-if="hasError('bookable_until')" class="text-danger">
                      {{ getError("bookable_until") }}
                    </p>
                  </section>
                  <!-- END Bookable to -->
                </div>

                <div class="row">
                  <!-- BEGIN Max participants -->
                  <section class="col col-6">
                    <text-input
                      v-model="selectedEvent.max_participants"
                      id="event-max-participants"
                      :label="
                        $label('event.max_participants', 'Max. participants')
                      "
                      :has-error="hasError('max_participants')"
                      :error="getError('max_participants')"
                      :is-disabled="updating"
                      @keyup.native.enter="createOrUpdateEvent"
                    />
                  </section>
                  <!-- END Max participants -->

                  <!-- BEGIN Online max participants -->
                  <section class="col col-6">
                    <text-input
                      v-model="selectedEvent.online_max_participants"
                      id="event-online-max-participants"
                      :label="
                        $label(
                          'event.online_max_participants',
                          'Online max. participants'
                        )
                      "
                      :has-error="hasError('online_max_participants')"
                      :error="getError('online_max_participants')"
                      :is-disabled="updating"
                      @keyup.native.enter="createOrUpdateEvent"
                    />
                  </section>
                  <!-- END Online max participants -->
                </div>

                <div class="row">
                  <!-- BEGIN Waitlist enabled -->
                  <section class="col col-6">
                    <label class="label">{{
                      $label("event.enable_waitlist", "Enable waitlist")
                    }}</label>
                    <label class="select">
                      <select
                        v-model="selectedEvent.waitlist_enabled"
                        id="event-waitlist-enabled"
                      >
                        <option value="true">{{
                          $label("common.yes", "Yes")
                        }}</option>
                        <option value="false">{{
                          $label("common.no", "No")
                        }}</option>
                      </select>
                      <i></i>
                    </label>
                    <p v-if="hasError('waitlist_enabled')" class="text-danger">
                      {{ getError("waitlist_enabled") }}
                    </p>
                  </section>
                  <!-- END Waitlist enabled -->

                  <!-- BEGIN Waitlist max places -->
                  <section
                    class="col col-6"
                    :class="{
                      'is-disabled':
                        selectedEvent.waitlist_enabled == null ||
                        selectedEvent.waitlist_enabled == false
                    }"
                  >
                    <text-input
                      v-model="selectedEvent.waitlist_max_places"
                      id="event-waitlist-places"
                      :label="
                        $label('event.waitlist_places', 'Waitlist places')
                      "
                      :has-error="hasError('waitlist_max_places')"
                      :error="getError('waitlist_max_places')"
                      :is-disabled="updating"
                      @keyup.native.enter="createOrUpdateEvent"
                    />
                  </section>
                  <!-- END Waitlist max places -->
                </div>

                <!-- BEGIN Widget note -->
                <section>
                  <label class="label">{{
                    $label("event.widget_note", "Widget note")
                  }}</label>
                  <label class="textarea">
                    <textarea
                      :class="{ 'text-input-error': hasError('widget_note') }"
                      :placeholder="$label('event.widget_note', 'Widget note')"
                      :disabled="updating"
                      id="event-widget-note"
                      rows="1"
                    >
                    </textarea>
                  </label>
                </section>
                <!-- EJD Widget note -->

                <!-- BEGIN Freebie -->
                <div class="row">
                  <section class="col col-12">
                    <label class="label">&nbsp;</label>
                    <label class="checkbox">
                      <input
                        v-model="selectedEvent.freebie"
                        id="event-freebie"
                        type="checkbox"
                        value="true"
                      /><i></i>
                      {{ $label("event.event_is_freebie", "Event is freebie") }}
                    </label>
                  </section>
                </div>
                <!-- END Freebie -->

                <!-- BEGIN Autofill waitlist -->
                <div class="row">
                  <section class="col col-12">
                    <label class="label">&nbsp;</label>
                    <label class="checkbox">
                      <input
                        v-model="selectedEvent.birthdate_mandatory"
                        id="event-birthdate-mandatory"
                        type="checkbox"
                        value="true"
                      /><i></i>
                      {{
                        $label(
                          "event.birthdate_is_mandatory",
                          "Birthdate is mandatory"
                        )
                      }}
                    </label>
                  </section>
                </div>
                <!-- END Autofill waitlist -->

                <!-- BEGIN Disable online payment -->
                <div class="row">
                  <section class="col col-12">
                    <label class="label">&nbsp;</label>
                    <label class="checkbox">
                      <input
                        v-model="selectedEvent.disable_online_payment"
                        id="event-disable-online-payment"
                        type="checkbox"
                        value="true"
                      /><i></i>
                      {{
                        $label(
                          "event.disable_online_payment_for_event",
                          "Disable online payment for this event"
                        )
                      }}
                    </label>
                  </section>
                </div>
                <!-- END Disable online payment -->

                <!-- BEGIN Autofill waitlist -->
                <div class="row">
                  <section class="col col-12">
                    <label class="label">&nbsp;</label>
                    <label class="checkbox">
                      <input
                        v-model="selectedEvent.waitlist_autofill_free_places"
                        id="event-autofill-free-places"
                        type="checkbox"
                        value="true"
                      /><i></i>
                      {{
                        $label(
                          "event.waitlist_autofill_free_places",
                          "Fill free waitlist places automatically"
                        )
                      }}
                    </label>
                  </section>
                </div>
                <!-- END Autofill waitlist -->

                <!-- BEGIN Cost center -->
                <div class="row">
                  <section class="col col-12">
                    <text-input
                      id="event-cost-center"
                      :label="$label('event.cost_center', 'Cost center')"
                      :has-error="hasError('cost_center')"
                      :error="getError('cost_center')"
                      :is-disabled="updating"
                      @keyup.native.enter="createOrUpdateEvent"
                    />
                  </section>
                </div>
                <!-- END Cost center -->
              </fieldset>
            </div>
          </div>
        </div>

        <div class="row"><div class="col-xs-12">&nbsp;</div></div>

        <div class="col-sm-6">
          <h2>
            <i class="fa fa-fw fa-lg fa-laptop"></i> Kalender & Infoscreen
          </h2>
          <p></p>
          <div class="v-form-partial">
            <div class="v-form">
              <fieldset>
                <div class="row">
                  <section class="col col-6">
                    <label class="label">Zeile 1</label>
                    <label class="input">
                      <input type="text" value="" placeholder="Beschriftung" />
                    </label>
                  </section>

                  <section class="col col-6">
                    <label class="label">Zeile 2</label>
                    <label class="input">
                      <input type="text" value="" placeholder="Anzeigewert" />
                    </label>
                  </section>
                </div>
                <div class="row">
                  <section class="col col-6">
                    <label class="label">Farbcode</label>
                    <label class="input">
                      <input
                        type="text"
                        value=""
                        id="color-code"
                        data-control="wheel"
                      />
                    </label>
                  </section>
                  <section class="col col-6">
                    <label class="label">Infotext</label>
                    <label class="input">
                      <input
                        type="text"
                        value=""
                        name="new_text"
                        placeholder="Neu"
                      />
                    </label>
                  </section>
                </div>
              </fieldset>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <h2>
            <i class="fa fa-fw fa-lg fa-users"></i>
            {{ $label("event.audiences", "Audiences") }}
          </h2>
          <p></p>
          <div class="v-form-partial">
            <div class="v-form">
              <fieldset>
                <section>
                  <label class="label font-bold">Zielgruppe:</label>
                </section>
                <div class="row">
                  <!-- BEGIN Audiences -->
                  <section class="col col-12" id="event-audiences-multiselect">
                    <label class="label typo__label">
                      {{ $label("event.audiences", "Audiences") }}</label
                    >
                    <multiselect
                      v-model="audienceValue"
                      tag-placeholder=""
                      :placeholder="
                        $label(
                          'event.search_or_add_audience',
                          'Search or add audience'
                        )
                      "
                      label="name"
                      track-by="id"
                      :options="audienceOptions"
                      class="v-multiselect v-form"
                      :multiple="true"
                      :taggable="false"
                      :show-labels="false"
                      @tag="addAudience"
                    >
                    </multiselect>
                    <div>
                      <a
                        @click="audienceValue = audienceOptions"
                        class="note action-link pull-right"
                        id="selectAllAudiences"
                        >{{ $label("event.select_all", "Select all") }}</a
                      >
                      &nbsp;
                      <a
                        @click="audienceValue = []"
                        class="note action-link pull-right"
                        id="removeAllAudiences"
                        >{{ $label("event.select_all", "Remove all") }}</a
                      >
                    </div>

                    <p v-if="hasError('audience_ids')" class="text-danger">
                      {{ getError("audience_ids") }}
                    </p>
                  </section>
                  <!-- END Audiences -->
                </div>

                <div v-show="!disableParticipantBirthdate" class="row">
                  <section class="col col-3">
                    <label class="label">Alter Von</label>
                    <label class="input">
                      <input type="text" value="" />
                    </label>
                  </section>
                  <section class="col col-3">
                    <label class="label">Bis</label>
                    <label class="input">
                      <input type="text" value="" />
                    </label>
                  </section>
                </div>
                <div v-show="courseAgeFormatted" class="row">
                  <section class="col col-12">
                    <label class="note">
                      $this->courseAgeFormatted
                    </label>
                  </section>
                </div>
                <section v-show="supportSchoolClass">
                  <label class="label">Schulklasse</label>
                  <label class="textarea">
                    <select name="course_class[]" multiple style="width: 100%;">
                      <option value="" selected>Schulklasse</option>
                    </select>
                  </label>
                </section>
              </fieldset>
            </div>
          </div>
        </div>

        <div class="row"><div class="col-xs-12">&nbsp;</div></div>

        <div class="col-sm-6">
          <h2>
            <i class="fa fa-fw fa-lg fa-picture-o"></i>
            {{ $label("event.event-image", "Event image") }}
          </h2>
          <p></p>
          <div class="v-form-partial">
            <div class="v-form v-form-box">
              <fieldset class="venue-images">
                <div class="row text-center">
                  <div class="col-sm-7">
                    <div
                      id="img_preview"
                      style="cursor: pointer;"
                      data-toggle="modal"
                      data-target="#eventImgModal"
                    >
                      <img
                        :src="url"
                        class="img-responsive img-thumbnail col-12 col"
                      />
                    </div>
                  </div>
                  <div class="col-sm-5 center text-center">
                    <div class="text-center venue-image-actions">
                      <button
                        id="edit-event-image"
                        class="btn btn-primary btn-block v-form-btn"
                        :class="{
                          'is-disabled':
                            !readWriteAccess || !eventImageRemovable
                        }"
                        v-tooltip="{
                          content: $label('common.edit_image', 'Edit image'),
                          classes: 'custom-tooltip'
                        }"
                        data-toggle="modal"
                        data-target="#eventImgModal"
                      >
                        <i class="fa fa-lg fa-fw fa-pencil"></i>
                        {{ $label("common.edit_image", "Edit image") }}
                      </button>
                      <button
                        id="delete-event-image"
                        class="btn btn-primary btn-block v-form-btn"
                        :class="{
                          'is-disabled':
                            !readWriteAccess ||
                            !eventImageRemovable ||
                            selectedEventId == null ||
                            url == placeHolderUrl
                        }"
                        v-tooltip="{
                          content: $label(
                            'common.delete_image',
                            'Delete image'
                          ),
                          classes: 'custom-tooltip'
                        }"
                        @click="onDeleteEventImage"
                      >
                        <i class="fa fa-lg fa-fw fa-trash-o"></i>
                        {{ $label("common.delete_image", "Delete image") }}
                      </button>
                      <button
                        id="upload-event-image"
                        class="btn btn-primary btn-block v-form-btn"
                        :class="{ 'is-disabled': !readWriteAccess }"
                        data-btn="upload"
                        v-tooltip="{
                          content: $label('common.new_image', 'New image'),
                          classes: 'custom-tooltip'
                        }"
                        data-toggle="modal"
                        data-target="#eventImgModal"
                      >
                        <i class="fa fa-lg fa-fw fa-upload"></i>
                        {{ $label("common.new_image", "New image") }}
                      </button>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <h2>
            <i class="fa fa-fw fa-lg fa-file-pdf-o"></i>
            {{ $label("event.event_brochures", "Event brochures") }}
          </h2>
          <p></p>

          <div
            class="v-form-partial"
            :class="{ 'is-disabled': selectedEventId == null }"
          >
            <div class="v-form">
              <fieldset>
                <section>
                  <label class="label">
                    {{ $label("event.upload_new_files", "Upload new files") }}
                    ({{ $label("common.max", "max.") }}
                    {{ maxNumberOfFiles }}
                    {{ $label("event.files_per_event", " files per event") }})
                  </label>
                  <vue-dropzone
                    ref="brochuresDropzone"
                    id="brochures-dropzone"
                    :options="dropzoneOptions"
                    @vdropzone-success="onUploadBrochureFile"
                  >
                  </vue-dropzone>
                </section>
                <section v-show="brochures == null || brochures.length > 0">
                  <label class="label">{{
                    $label(
                      "event.latest_event_brochures",
                      "Latest event brochures"
                    )
                  }}</label>
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>{{ $label("common.file", "File") }}</th>
                        <th class="text-center">
                          {{ $label("common.actions", "Actions") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody id="files-table">
                      <tr
                        v-for="brochure in brochures"
                        v-bind:key="brochure.id"
                      >
                        <td>{{ brochure.original_name }}</td>
                        <td class="text-center">
                          <a
                            :id="'event-download-brochure-' + brochure.id"
                            :href="brochure.url"
                            class="btn btn-primary"
                            v-tooltip="{
                              content: $label('common.download', 'Download'),
                              classes: 'custom-tooltip'
                            }"
                            ><i
                              class="fa fa-fw fa-cloud-download"
                              style="color: white !important;"
                            ></i
                          ></a>
                          &nbsp;
                          <a
                            :id="'event-delete-brochure-' + brochure.id"
                            @click="deleteEventBrochure(brochure.id)"
                            class="btn btn-danger"
                            v-tooltip="{
                              content: $label('common.delete', 'Delete'),
                              classes: 'custom-tooltip'
                            }"
                            ><i
                              class="fa fa-fw fa-trash-o"
                              style="color: white !important;"
                            ></i
                          ></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </fieldset>
            </div>
          </div>
        </div>

        <div class="row mb-4"><div class="col-xs-12">&nbsp;</div></div>

        <hr />

        <div class="row">
          <div class="col-xs-12 text-center">
            <back-button
              back-link="Events"
              :class="{ 'is-disabled': updating }"
              id="back-event-button"
              icon="fa fa-lg fa-fw fa-arrow-circle-o-left"
              :text="$label('common.back', 'Back')"
            >
            </back-button>
            &nbsp;
            <info-button
              :class="{ 'is-disabled': updating || !readWriteAccess }"
              id="save-event-button"
              icon="fa fa-lg fa-fw fa-save"
              :text="$label('common.save', 'Save')"
              @click.native="createOrUpdateEvent"
            >
            </info-button>
            &nbsp;
            <warning-button
              :class="{
                'is-disabled':
                  updating || !readWriteAccess || selectedEventId == null
              }"
              id="cancel-event-button"
              icon="fa fa-fw fa-lg fa-pause"
              :text="$label('event.cancel', 'Cancel')"
            >
            </warning-button>
            &nbsp;
            <danger-button
              :class="{
                'is-disabled':
                  updating || selectedEventId == null || !readWriteAccess
              }"
              id="delete-event-button"
              icon="fa fa-fw fa-lg fa-trash-o"
              :text="$label('common.delete', 'Delete')"
              @click.native="deleteEvent"
            >
            </danger-button>
          </div>
        </div>
      </div>

      <div class="row mb-4"><div class="col-xs-12">&nbsp;</div></div>
    </template>
  </div>
</template>

<script>
import Api from "@/api.js";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";
import Multiselect from "vue-multiselect";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import NavigationTabs from "@/components/Settings/Events/EventDetails/NavigationTabs.vue";

import ViewLoader from "@/components/Common/ViewLoader";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton";
import WarningButton from "@/components/Common/Buttons/WarningButton";
import BackButton from "@/components/Common/Buttons/BackButton";
import DangerButton from "@/components/Common/Buttons/DangerButton";
import Error404 from "@/components/Common/Error404";

export default {
  name: "EventDetails.vue",

  mixins: [FormErrorsMixin],

  components: {
    ViewLoader,
    NavigationTabs,
    TextInput,
    InfoButton,
    BackButton,
    DangerButton,
    WarningButton,
    Multiselect,
    DatePicker,
    vueDropzone: vue2Dropzone,
    Error404
  },

  data() {
    return {
      loading: false,
      updating: false,
      noDataExist: false,
      dateFormat: "DD.MM.YYYY",
      dateTimeFormat: "DD.MM.YYYY HH:mm:ss",
      readWriteAccess: true,
      disableParticipantBirthdate: false,
      courseAgeFormatted: true,
      supportSchoolClass: true,
      eventImageRemovable: true,
      handleEventHost: true,
      accountableByInstructor: true,
      accountingBy: "instructor",
      maxNumberOfFiles: 2,
      originalName: null,
      selectedEvent: {
        name: null,
        short_name: null,
        type: null,
        bookability: null,
        bookable_online: false,
        bookable_from: null,
        bookable_until: null,
        start_date: null,
        end_date: null,
        freebie: false,
        waitlist_enabled: false,
        waitlist_max_places: null,
        waitlist_autofill_free_places: false,
        birthdate_mandatory: false,
        max_participants: null,
        online_max_participants: null,
        disable_online_payment: false,
        instructor_ids: [],
        audience_ids: []
      },
      selectedEventId: null,
      failedRequest: false,
      validatedInputs: [
        "name",
        "short_name",
        "type",
        "bookability",
        "bookable_online",
        "bookable_from",
        "bookable_until",
        "start_date",
        "end_date",
        "freebie",
        "waitlist_enabled",
        "waitlist_max_places",
        "waitlist_autofill_free_places",
        "birthdate_mandatory",
        "max_participants",
        "online_max_participants",
        "disable_online_payment",
        "instructor_ids",
        "audience_ids"
      ],
      // Audiences
      audienceValue: [],
      audienceOptions: [],
      // Groups
      groupValue: [],
      groupOptions: [],
      // Event Types
      eventTypes: [],
      // Instructors
      instructorValue: [],
      instructorOptions: [],
      instructorSearchFilter: "",
      // Image
      placeHolderUrl: require("@/assets/img/default-event.png"),
      url: require("@/assets/img/default-event.png"),
      newUrl: null,
      originalEventImageUrl: null,
      eventImage: null,
      // Dropzone for brochures
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 5,
        addRemoveLinks: true,
        uploadMultiple: false,
        parallelUploads: 1,
        maxFiles: 1,
        acceptedFiles: "application/pdf",
        dictDefaultMessage:
          '<i class="fa fa-cloud-upload"></i> Drop files here to upload',
        dictMaxFilesExceeded: "Max. number of uploads reached"
      },
      // Brochures
      brochures: []
    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.selectedEventId = vm.$route.params.event_id;
      vm.getInstructors();
      vm.getAudiences();
      vm.getGroups();
      vm.getEventTypes();

      if (
        typeof vm.selectedEventId !== "undefined" &&
        vm.selectedEventId !== null
      ) {
        if (vm.$route.query.event_created) {
          swal("Success!", "The event was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        vm.getEvent(() => {
          //
        });
      } else {
        vm.newUrl = vm.placeHolderUrl;
      }
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.getInstructors();
    this.getAudiences();
    this.getGroups();
    this.getEventTypes();

    if (
      typeof this.selectedEventId !== "undefined" &&
      this.selectedEventId !== null
    ) {
      this.getEvent(() => {
        //
      });
    } else {
      this.newUrl = this.placeHolderUrl;
    }
    next();
  },

  mounted() {
    //
  },

  methods: {
    onUploadBrochureFile(file) {
      if (this.brochures.length < 2) {
        this.uploadEventBrochure(file);
      }
      this.$refs.brochuresDropzone.removeFile(file);
    },

    addGroup(group) {
      this.groupValue.push(group);
    },

    addAudience(audience) {
      this.audienceValue.push(audience);
    },

    addInstructor(instructor) {
      this.instructorValue.push(instructor);
    },

    createOrUpdateEvent() {
      if (this.selectedEventId == null) {
        this.createEvent();
      } else {
        this.updateEvent();
      }
    },

    createEvent() {
      if (this.updating) {
        return;
      }
      this.resetErrors();

      if (this.instructorValue != null && this.instructorValue.length > 0) {
        for (let i = 0; i < this.instructorValue.length; i++) {
          this.selectedEvent.instructor_ids.push(this.instructorValue[i].id);
        }
      }

      if (this.audienceValue != null && this.audienceValue.length > 0) {
        for (let i = 0; i < this.audienceValue.length; i++) {
          this.selectedEvent.audience_ids.push(this.audienceValue[i].id);
        }
      }

      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint("events");

      let startDate = this.selectedEvent.start_date;
      this.selectedEvent.start_date = this.convertDate(startDate);
      let endDate = this.selectedEvent.end_date;
      this.selectedEvent.end_date = this.convertDate(endDate);
      let bookableFrom = this.selectedEvent.bookable_from;
      this.selectedEvent.bookable_from = this.convertDateTime(bookableFrom);
      let bookableUntil = this.selectedEvent.bookable_until;
      if (this.selectedEvent.bookable_until != null) {
        this.selectedEvent.bookable_until = this.convertDateTime(bookableUntil);
      }

      this.selectedEvent.waitlist_enabled =
        this.selectedEvent.waitlist_enabled === "true" ? true : false;

      Api()
        .post(endpoint, this.selectedEvent)
        .then(response => {
          this.selectedEventId = response.data.data.id;
          if (
            this.originalEventImageUrl != this.url &&
            this.url != null &&
            this.url != this.placeHolderUrl
          ) {
            this.updateEventImage("create");
          } else {
            this.$router.push({
              name: "EventDetails",
              params: { event_id: this.selectedEventId },
              query: { event_created: true }
            });
          }
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
          this.$scrollTo("#event-name", 500);
          this.selectedEvent.start_date = startDate;
          this.selectedEvent.end_date = endDate;
          this.selectedEvent.bookable_from = bookableFrom;
          this.selectedEvent.bookable_until = bookableUntil;
        })
        .finally(() => {
          this.updating = false;
        });
    },

    getEvent() {
      this.resetErrors();
      this.loading = true;
      const endpoint = this.$partnerEndpoint("events/" + this.selectedEventId);

      Api()
        .get(endpoint)
        .then(response => {
          this.selectedEvent = response.data.data;
          this.selectedEvent.start_date = this.convertDate(
            this.selectedEvent.start_date,
            response.data.data.start_date
          );
          this.selectedEvent.end_date = this.convertDate(
            this.selectedEvent.end_date,
            response.data.data.end_date
          );
          this.selectedEvent.bookable_from = this.convertDateTime(
            this.selectedEvent.bookable_from,
            response.data.data.bookable_from
          );
          this.selectedEvent.bookable_until = this.convertDateTime(
            this.selectedEvent.bookable_until,
            response.data.data.bookable_until
          );
          this.originalName = this.selectedEvent.name;
          if (response.data.data.image != null) {
            this.url = response.data.data.image.url;
            this.originalEventImageUrl = this.url;
            this.newUrl = this.url;
          } else {
            this.newUrl = this.placeHolderUrl;
          }
          this.getEventBrochures();
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.noDataExist = true;
          }
          console.log(error.response);
        })
        .finally(() => {
          this.loading = false;

          // filter instructors
          if (
            this.selectedEvent != null &&
            this.selectedEvent.instructor_ids != null &&
            this.selectedEvent.instructor_ids > 0
          ) {
            for (let i = 0; i < this.instructorOptions.length; i++) {
              for (
                let j = 0;
                j < this.selectedEvent.instructor_ids.length;
                j++
              ) {
                if (
                  this.selectedEvent.instructor_ids[j].id ==
                  this.instructorOptions[i].id
                ) {
                  this.addCategory({
                    name: this.instructorOptions[i].name,
                    id: this.instructorOptions[i].id
                  });
                }
              }
            }
          }

          // filter audiences
          if (
            this.selectedEvent != null &&
            this.selectedEvent.audience_ids != null &&
            this.selectedEvent.audience_ids > 0
          ) {
            for (let i = 0; i < this.instructorOptions.length; i++) {
              for (let j = 0; j < this.selectedEvent.audience_ids.length; j++) {
                if (
                  this.selectedEvent.audience_ids[j].id ==
                  this.audienceOptions[i].id
                ) {
                  this.addCategory({
                    name: this.audienceOptions[i].name,
                    id: this.audienceOptions[i].id
                  });
                }
              }
            }
          }
        });
    },

    updateEvent() {
      if (this.loading || this.updating) {
        return;
      }

      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint("events/" + this.selectedEventId);

      let startDate = this.selectedEvent.start_date;
      this.selectedEvent.start_date = this.convertDate(startDate);
      let endDate = this.selectedEvent.end_date;
      this.selectedEvent.end_date = this.convertDate(endDate);
      let bookableFrom = this.selectedEvent.bookable_from;
      this.selectedEvent.bookable_from = this.convertDateTime(bookableFrom);
      let bookableUntil = this.selectedEvent.bookable_until;
      if (this.selectedEvent.bookable_until != null) {
        this.selectedEvent.bookable_until = this.convertDateTime(bookableUntil);
      }

      delete this.selectedEvent.image;

      Api()
        .put(endpoint, this.selectedEvent)
        .then(() => {
          if (
            this.originalEventImageUrl != this.url &&
            this.url != null &&
            this.url != this.placeHolderUrl
          ) {
            this.updateEventImage("update");
          } else {
            this.getEvent(() => {
              //
            });
          }
          swal({
            title: "Success!",
            text: "The event was updated.",
            icon: "success"
          });
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
          this.$scrollTo("#event-name", 500);
          this.selectedEvent.start_date = startDate;
          this.selectedEvent.end_date = endDate;
          this.selectedEvent.bookable_from = bookableFrom;
          this.selectedEvent.bookable_until = bookableUntil;
        })
        .finally(() => {
          this.updating = false;
        });
    },

    deleteEvent() {
      if (this.loading || this.updating) {
        return;
      }

      swal({
        title: "Are you sure?",
        text: "The event will be deleted",
        icon: "warning",
        dangerMode: true,
        buttons: {
          cancel: {
            visible: true,
            text: "Cancel",
            closeModal: true
          },
          confirm: {
            visible: true,
            text: "Yes, delete it!",
            closeModal: true
          }
        }
      }).then(isConfirm => {
        if (isConfirm) {
          const endpoint = this.$partnerEndpoint(
            "events/" + this.selectedEventId
          );

          Api()
            .delete(endpoint)
            .then(() => {
              this.$router.push({
                name: "Events",
                query: { event_deleted: true }
              });
            })
            .catch(error => {
              console.log(error.response);
              if (error.response.status === 403) {
                swal({
                  title: "Missing permission",
                  text: "You are not allowed to delete events.",
                  icon: "error"
                  //dangerMode: true,
                });
              }
            });
        } else {
          //
        }
      });
    },

    updateEventImage(origin) {
      if (this.loading || this.updating) {
        return;
      }

      this.resetErrors();
      this.updating = true;
      const endpoint = this.$partnerEndpoint(
        "events/" + this.selectedEventId + "/image"
      );

      let formData = new FormData();
      if (this.eventImage != null) {
        formData.append("image", this.eventImage);
        formData.append("_method", "put");
      } else {
        return;
      }

      Api()
        .post(endpoint, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          if (origin == "create") {
            this.$router.push({
              name: "EventDetails",
              params: { event_id: this.selectedEventId },
              query: { event_created: true }
            });
          }
          if (origin == "update") {
            swal({
              title: "Success!",
              text: "The event was updated.",
              icon: "success"
            });
          }
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
          this.$scrollTo("#event-name", 500);
        })
        .finally(() => {
          this.updating = false;
        });
    },

    getEventBrochures() {
      this.loading = true;
      const endpoint = this.$partnerEndpoint(
        "events/" + this.selectedEventId + "/brochures"
      );

      Api()
        .get(endpoint)
        .then(response => {
          this.brochures = response.data.data;
          if (this.brochures.length >= 2) {
            this.$refs.brochuresDropzone.disable();
          } else {
            this.$refs.brochuresDropzone.enable();
          }
        })
        .catch(error => {
          console.log(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    uploadEventBrochure(brochureFile) {
      if (this.loading || this.updating) {
        return;
      }

      this.resetErrors();
      this.updating = true;

      let formData = new FormData();
      if (brochureFile != null) {
        formData.append("brochure", brochureFile);
        formData.append("_method", "post");
      } else {
        return;
      }

      const endpoint = this.$partnerEndpoint(
        "events/" + this.selectedEventId + "/brochures"
      );

      Api()
        .post(endpoint, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(() => {
          this.getEventBrochures();
        })
        .catch(error => {
          this.storeErrors(error.response.data.errors);
          this.$scrollTo("#event-name", 500);
        })
        .finally(() => {
          this.updating = false;
        });
    },

    deleteEventBrochure(brochureId) {
      const endpoint = this.$partnerEndpoint(
        "events/" + this.selectedEventId + "/brochures/" + brochureId
      );

      Api()
        .delete(endpoint)
        .then(() => {
          this.getEventBrochures();
        })
        .catch(error => {
          console.log(error.response);
          if (error.response.status === 403) {
            swal({
              title: "Missing permission",
              text: "You are not allowed to delete event brochures.",
              icon: "error"
              //dangerMode: true,
            });
          }
        });
    },

    getAudiences(successCallback) {
      this.loading = true;
      this.audienceOptions = [];
      const endpoint = this.$partnerEndpoint("audiences");

      Api()
        .get(endpoint)
        .then(response => {
          this.audienceOptions = response.data.data;
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getGroups(successCallback) {
      this.loading = true;
      this.groupOptions = [];
      const endpoint = this.$partnerEndpoint("groups");

      Api()
        .get(endpoint)
        .then(response => {
          this.groupOptions = response.data.data;
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getEventTypes(successCallback) {
      this.loading = true;
      this.eventTypes = [];
      const endpoint = this.$partnerEndpoint("events/types");

      Api()
        .get(endpoint)
        .then(response => {
          this.eventTypes = response.data.data;
          if (!this.selectedEventId) {
            this.selectedEvent.type = this.eventTypes[0];
          }
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getInstructors(successCallback) {
      this.instructorOptions = [];
      const endpoint = this.$partnerEndpoint("instructors");

      Api()
        .get(endpoint, {
          params: {
            page: 1,
            search: this.instructorSearchFilter
          }
        })
        .then(response => {
          this.instructorOptions = response.data.data;
          this.failedRequest = false;
          if (typeof successCallback == "function") {
            successCallback();
          }
        })
        .catch(() => {
          this.failedRequest = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onImageFileChange(e) {
      const file = e.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      this.newUrl = URL.createObjectURL(file);
    },

    onUpdateEventImage() {
      this.url = this.newUrl;
      this.eventImage = this.$refs.eventImage.files[0];
    },

    onDeleteEventImage() {
      this.deleteEventImage();
    },

    updateInstructorSearchFilter(search) {
      this.instructorSearchFilter = search;
      this.getInstructors(() => {
        //
      });
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.mb-4 {
  margin-bottom: 1.2rem;
}
</style>
